import { useEffect, useRef } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Properties';
import CTA from './components/CTA';
import Footer from './components/Footer';

declare global {
  interface Window { VANTA: any; THREE: any; }
}

export default function HomePage() {
  const vantaRef = useRef<HTMLDivElement>(null);
  const vantaEffect = useRef<any>(null);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;

    const loadScripts = async () => {
      if (!window.THREE) {
        await new Promise<void>((resolve) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js';
          script.onload = () => resolve();
          document.head.appendChild(script);
        });
      }
      if (!window.VANTA) {
        await new Promise<void>((resolve) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.net.min.js';
          script.onload = () => resolve();
          document.head.appendChild(script);
        });
      }
      if (vantaRef.current && !vantaEffect.current) {
        vantaEffect.current = window.VANTA.NET({
          el: vantaRef.current,
          mouseControls: !isMobile,
          touchControls: false,       // disable touch drag on mobile
          gyroControls: false,
          minHeight: 200.0,
          minWidth: 200.0,
          scale: 1.0,
          scaleMobile: 0.5,           // shrink the whole net on mobile
          color: 0x4A9EE8,
          backgroundColor: 0x030810,
          // Mobile: fewer points, more spread out, shorter lines
          points: isMobile ? 3.0 : 8.0,
          maxDistance: isMobile ? 18.0 : 22.0,
          spacing: isMobile ? 40.0 : 22.0,
        });
      }
    };
    loadScripts();
    return () => {
      if (vantaEffect.current) {
        vantaEffect.current.destroy();
        vantaEffect.current = null;
      }
    };
  }, []);

  return (
    <div style={{ backgroundColor: '#030810' }}>
      {/* Fixed Vanta background */}
      <div
        ref={vantaRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 0,
        }}
      />
      {/* Content scrolls over the fixed background */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <Navbar />
        <Hero />
        <About />
        <Services />
        <Projects />
        <CTA />
        <Footer />
      </div>
    </div>
  );
}
